// eslint-disable-next-line jira/wrm/no-load-bridge
import { loadBridge, loadBridgeStrict } from '@atlassian/jira-common-bridge/src';
import { fg } from '@atlassian/jira-feature-gating';

const amdModuleName = 'jira-agile/sidebar/create-board-adg3';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (): Promise<void> => {
	let module;

	if (fg('create_board_modal_replace_deprecated_load_bridge')) {
		// eslint-disable-next-line jira/wrm/no-load-bridge
		module = await loadBridgeStrict({
			name: amdModuleName,
			wrmKeys: ['wrc!com.pyxis.greenhopper.jira:gh-create-board'],
		});
	} else {
		// eslint-disable-next-line jira/wrm/no-load-bridge
		module = await loadBridge({ name: amdModuleName });
	}

	// @ts-expect-error - TS2571 - Object is of type 'unknown'.
	return module.openCreateBoardModal();
};
